import React from 'react';
import TimeSettingForm from 'components/organismos/master/labor/TimeSettingsForm';
import SidebarTemplate from 'components/templates/SidebarTemplate';

const TimeSettingPage = () => (
  <SidebarTemplate>
    <TimeSettingForm />
  </SidebarTemplate>
);

export default TimeSettingPage;
